if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartInfo = document.querySelector('cart-notification') || document.querySelector('cart-drawer')

      this.submitButton = this.querySelector('[type="submit"]');

    }
    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cartInfo) {
        formData.append('sections', this.cartInfo.getSectionsToRender().map((section) => section.id) );
        formData.append('sections_url', window.location.pathname);
        this.cartInfo.setActiveElement(document.activeElement);
      }
      config.body = formData;

      const productId = this.form.querySelector('input[name="id"]').value


      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);


            // const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            // if (!soldOutMessage) return;
            // this.submitButton.setAttribute('aria-disabled', true);
            // this.submitButton.querySelector('span').classList.add('hidden');
            // soldOutMessage.classList.remove('hidden');


            this.error = true;

            return;
          } else if (!this.cartInfo) {
            this.closest('.data-info-product') != null ? this.closest('.data-info-product').removeAttribute('aria-disabled') : ''
            this.closest('.data-m-x-rif') != null ? this.closest('.data-m-x-rif').innerHTML = '' : null

            window.location = window.routes.cart_url;
            return;
          }
          this.cartInfo.renderContents(response, productId);
          // this.cartInfo.open();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {





          this.submitButton.classList.remove('loading');
          if (this.cartInfo && this.cartInfo.classList.contains('is-empty')) this.cartInfo.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');


        });

    }

    handleErrorMessage(errorMessage = false) {

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {

        if(errorMessage.email){
          this.errorMessage.textContent = errorMessage.email[0];
        }else{
          this.errorMessage.textContent = errorMessage;
        }

        this.errorMessageWrapper.classList.add('active')

      }

    }

  });
}

if (!customElements.get('close-form-x')) {

  customElements.define('close-form-x', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.closeXi.bind(this))
    }
    closeXi(e){
      this.closest('.data-info-product') != null ? this.closest('.data-info-product').removeAttribute('aria-disabled') : ''
      this.closest('.data-m-x-rif') != null ? this.closest('.data-m-x-rif').innerHTML = '' : null
    }
  })

}

